import type { TourConfig } from '../types';

export const commissionRulesPageTour: TourConfig = {
  pageId: 'commission-rules',
  pageName: 'Commission Rules',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="add-rule"]',
      title: 'Add Rule',
      intro:
        'Create a new commission rule. Each rule maps a business + project type to a commission percentage or flat amount.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="rules-table"]',
      title: 'Rules Table',
      intro:
        'View all configured commission rules. Edit, activate/deactivate, or delete rules from the Actions column.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="business-toggle"]',
      title: 'Business Filter',
      intro:
        'Toggle between businesses to see rules specific to each. Rules are configured per-business.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
